module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_buiding-3c138482dc7ebaa1e39adaa22d5f4311.png";